var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"mb-sm"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-one-third"},[_c('h1',{staticClass:"has-text-centered is-size-4"},[_vm._v("Subscription Success")])])])])])])
}]

export { render, staticRenderFns }